import ScrollItem from './ScrollItem';
import './Movie.css';

import BIBITWebp from '../img/backedBy-BYBIT.webp';
import BIBIT from '../img/backedBy-BYBIT.png';
import GateioWebp from '../img/backedBy-Gateio.webp';
import Gateio from '../img/backedBy-Gateio.png';
import MEXCWebp from '../img/backedBy-MEXC.webp';
import MEXC from '../img/backedBy-MEXC.png';
import OVOWebp from '../img/backedBy-OVO.webp';
import OVO from '../img/backedBy-OVO.png';

export default function Movie() {
    return (
        <section className="Movie">
            <ScrollItem>
                <div className="Movie__youtube">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/GN5Un-Fgt1U?rel=0"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
                </div>
            </ScrollItem>

            <ScrollItem>
                <p className="Movie__h2">Partner with</p>
            </ScrollItem>
            <div className="Movie__backedByContainer">
                <ScrollItem>
                    <div className="Movie__backedByContainer__item">
                        <a href="https://www.bybit.com/" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={BIBITWebp} />
                                <img src={BIBIT} alt="BIBIT logo" />
                            </picture>
                        </a>
                    </div>
                </ScrollItem>
                <ScrollItem>
                    <div className="Movie__backedByContainer__item">
                        <a href="https://www.gate.io/" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={GateioWebp} />
                                <img src={Gateio} alt="Gate.io logo" />
                            </picture>
                        </a>
                    </div>
                </ScrollItem>
                <ScrollItem>
                    <div className="Movie__backedByContainer__item">
                        <a href="https://www.mexc.com/" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={MEXCWebp} />
                                <img src={MEXC} alt="MEXC logo" />
                            </picture>
                        </a>
                    </div>
                </ScrollItem>
                <ScrollItem>
                    <div className="Movie__backedByContainer__item">
                        <a href="https://www.ovo.space/" target="_blank">
                            <picture>
                                <source type="image/webp" srcSet={OVOWebp} />
                                <img src={OVO} alt="OVO logo" />
                            </picture>
                        </a>
                    </div>
                </ScrollItem>
            </div>
        </section>
    );
}